import * as msgResource from '../../assets/resource/mensagem.json';
import * as msgConfig from '../../assets/resource/config.json';
import { OnInit } from '@angular/core';
import { SessaoService } from "../services/sessao.service";
import { Sessao } from "../modelo/sessao";
import { Mensagem } from '../modelo/mensagem';
import { FormGroup } from '@angular/forms';
import { Configuracao } from '../modelo/configuracao';
import { TreatString } from './treatString';

declare var $ :any;

export class AbstractComponent implements OnInit {

    form: FormGroup;
    sessao: Sessao;
    readonly: boolean;
    campos: string[];

    constructor(sessaoService: SessaoService)
    {
        this.sessao = sessaoService.sessao;
        this.campos = [];
    }

    ngOnInit() {

    }

    getMensagem = (chave: string): string => {
        var mensagens: Mensagem[] = <any>msgResource;
        return mensagens.find(w => w.chave == chave).texto;
    }

    getConfiguracao = (chave: string): string => {
        var mensagens: Configuracao[] = <any>msgConfig;
        return mensagens.find(w => w.chave == chave).valor;
    }

    alertWidth(): string{
        return this.getConfiguracao("BRA-ALERT-WIDTH");
    }

    formatCpfCnpj(numero: string): string {
        if(numero.length == 11){
            return TreatString.formatCpf(Number(numero));
        }
        else if(numero.length == 11){
            return TreatString.formatCnpj(Number(numero));
        }

        return numero.toString();
    }
 }



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/util/abstract.component.ts